module.exports = __webpack_public_path__ + "img/Instagram.e1d1ae33.png";